import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown, faDatabase, faLayerGroup, faChartBar,
  faThLarge, faDownload, faList, faUsers, faCog, faPlusCircle,
  faArchive, faCircleUser, faReceipt, faSignOut, faTrash, faPlus, faFile, faArrowCircleRight,
  faArrowUpRightFromSquare, faUserPolice, faEyeSlash, faTable, faCaretRight, faGripVertical,
  faXmark, faEye, faDoNotEnter, faExclamationTriangle as faExclamationTriangleSolid, faBan,
  faAsterisk, faThumbtack, faFileCsv, faFolder as faFolderSolid, faLock as facLockSolid,
  faCircleExclamation, faFileCircleCheck, faLockKeyhole, faMonitorWaveform as faMonitorWaveformSolid,
  faSquareInfo, faChevronDown as faChevronDownSolid,
  faClose, faTriangleExclamation, faPrint, faCheck
} from '@fortawesome/pro-solid-svg-icons';
import {
  faDatabase as faDatabaseLight, faLayerGroup as faLayerGroupLight,
  faChartBar as faChartBarLight, faThLarge as faThLargeLight,
  faList as faListLight, faDownload as faDownloadLight,
  faUsers as faUsersLight, faCog as faCogLight,
  faPlusCircle as faPlusCircleLight, faArchive as faArchiveLight,
  faCircleUser as faCircleUserLight,
  faClipboard as faClipboardLight,
  faArrowDownArrowUp, faGear, faTrash as faTrashLight, faPenToSquare,
  faArrowTurnDownRight, faChevronDown, faFile as faFileLight, faFolder as faFolderLight,
  faChartSimple, faFileHalfDashed, faCalculatorSimple, faFolderCheck, faMailbox, faPeopleGroup
} from '@fortawesome/pro-light-svg-icons';
import {
  faFileZipper, faDownload as faDownloadRegular, faEllipsisVertical, faCopy, faRotateExclamation,
  faFileExport, faFileImport, faHashtag, faText, faListUl, faSquareCaretDown, faCalendarDays, faLocationCrosshairs,
  faFileArrowUp, faQuoteLeft, faSquareSliders, faBarcodeRead, faFileSignature, faListTree, faPencil,
  faExclamationTriangle, faDotCircle, faCheckSquare, faCalendarAlt, faFolder, faFile as faFileRegular,
  faBarsProgress, faBoxArchive, faLock, faUnlock, faChevronLeft, faCirclePlus, faSignature, faEnvelope,
  faCircleCheck, faCircleXmark, faArrowRotateLeft, faArrowRotateRight, faFileLock, faWeightHanging, faFileCirclePlus, faChevronRight,
  faChartColumn, faChartPie, faChartLine, faTable as faTableRegular, faMonitorWaveform, faArrowRightArrowLeft,
  faCircleExclamation as faCircleExclamationRegular, faHeadset,
  faLeft, faRight, faClone
} from '@fortawesome/pro-regular-svg-icons';
import { faPenToSquare as faPenToSquareDuo, faSparkles } from '@fortawesome/pro-duotone-svg-icons';

// Import the icon definitions separately to correctly specify their types
const icons: { [key: string]: IconDefinition } = {
  faCaretDown,
  faDatabase,
  faDatabaseLight,
  faLayerGroup,
  faLayerGroupLight,
  faChartBar,
  faChartBarLight,
  faThLarge,
  faThLargeLight,
  faDownload,
  faDownloadLight,
  faDownloadRegular,
  faList,
  faListLight,
  faUsers,
  faUsersLight,
  faCog,
  faCogLight,
  faPlusCircle,
  faPlusCircleLight,
  faArchive,
  faArchiveLight,
  faCircleUser,
  faCircleUserLight,
  faReceipt,
  faSignOut,
  faFileZipper,
  faTrash,
  faPlus,
  faEllipsisVertical,
  faClipboardLight,
  faArrowDownArrowUp,
  faFile,
  faArrowUpRightFromSquare,
  faCopy,
  faUserPolice,
  faRotateExclamation,
  faEyeSlash,
  faFileExport,
  faFileImport,
  faGear,
  faHashtag,
  faText,
  faListUl,
  faSquareCaretDown,
  faCalendarDays,
  faLocationCrosshairs,
  faFileArrowUp,
  faQuoteLeft,
  faSquareSliders,
  faBarcodeRead,
  faFileSignature,
  faListTree,
  faTable,
  faPencil,
  faCaretRight,
  faExclamationTriangle,
  faGripVertical,
  faXmark,
  faTrashLight,
  faDotCircle,
  faCheckSquare,
  faCalendarAlt,
  faEye,
  faArrowTurnDownRight,
  faDoNotEnter,
  faExclamationTriangleSolid,
  faBan,
  faAsterisk,
  faThumbtack,
  faFileCsv,
  faFolder,
  faChevronDown,
  faFileRegular,
  faBarsProgress,
  faFolderSolid,
  faFolderCheck,
  faBoxArchive,
  faLock,
  faUnlock,
  facLockSolid,
  faChevronLeft,
  faFileLight,
  faFolderLight,
  faPenToSquare,
  faCirclePlus,
  faSignature,
  faEnvelope,
  faCircleCheck,
  faCircleXmark,
  faArrowRotateLeft,
  faFileLock,
  faArrowCircleRight,
  faWeightHanging,
  faCircleExclamation,
  faFileCircleCheck,
  faLockKeyhole,
  faFileCirclePlus,
  faPenToSquareDuo: faPenToSquareDuo as IconDefinition,
  faSparkles: faSparkles as IconDefinition,
  faChevronRight,
  faChartSimple,
  faChartColumn,
  faChartPie,
  faChartLine,
  faTableRegular,
  faFileHalfDashed,
  faMonitorWaveform,
  faMonitorWaveformSolid,
  faSquareInfo,
  faArrowRightArrowLeft,
  faCalculatorSimple,
  faCircleExclamationRegular,
  faChevronDownSolid,
  faClose,
  faHeadset,
  faArrowRotateRight,
  faTriangleExclamation,
  faLeft,
  faRight,
  faClone,
  faPrint,
  faMailbox,
  faPeopleGroup,
  faCheck
};

// Add the icons to the library
Object.values(icons).forEach(icon => library.add(icon));

// Export the FontAwesomeIcon component
export { FontAwesomeIcon };
